import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type OrgGuestFeedbackIntegrationSidebarQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID']['input'];
}>;


export type OrgGuestFeedbackIntegrationSidebarQuery = { __typename?: 'Query', OrgGuestFeedbackIntegration?: { __typename?: 'OrgGuestFeedbackIntegration', id: string, enabled: boolean, googleBusinessConfig?: { __typename?: 'OrgGuestFeedbackGoogleBusinessConfig', id: string, accountId: string } | null, locationGroup?: { __typename?: 'LocationGroup', id: string, name: string } | null, ovationIntegrationConfig?: { __typename?: 'OrgGuestFeedbackOvationIntegrationConfig', id: string, companyId: string } | null, tattleIntegrationConfig?: { __typename?: 'OrgGuestFeedbackTattleIntegrationConfig', id: string, merchantId: string } | null, locations: Array<{ __typename?: 'OrgGuestFeedbackIntegrationLocation', id: string, sourceLocationId: string, sourceName?: string | null, sourceAddress?: { __typename?: 'Address', lineOne: string, city: string, usState?: USState | null, postalCode: string } | null, location?: { __typename?: 'Location', id: number, name: string, address?: { __typename?: 'Address', lineOne: string, city: string, usState?: USState | null, postalCode: string } | null } | null }> } | null };

export type GuestFeedbackIntegrationOpusLocationsQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.LocationsInput>;
  pagination?: Types.InputMaybe<Types.PaginationInput>;
}>;


export type GuestFeedbackIntegrationOpusLocationsQuery = { __typename?: 'Query', Locations: { __typename?: 'Locations', objects: Array<{ __typename?: 'Location', id: number, name: string, address?: { __typename?: 'Address', lineOne: string, city: string, usState?: USState | null, postalCode: string } | null }> } };

export type GuestFeedbackIntegrationBrandsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GuestFeedbackIntegrationBrandsQuery = { __typename?: 'Query', LocationGroups: { __typename?: 'LocationGroups', objects: Array<{ __typename?: 'LocationGroup', id: string, name: string }> } };

export type UpdateOrgGuestFeedbackIntegrationBrandMutationVariables = Types.Exact<{
  input: Types.UpdateOrgGuestFeedbackIntegrationInput;
}>;


export type UpdateOrgGuestFeedbackIntegrationBrandMutation = { __typename?: 'Mutation', updateOrgGuestFeedbackIntegration: { __typename?: 'OrgGuestFeedbackIntegrationMutationResult', success: boolean, error?: { __typename?: 'Error', message?: string | null } | null, orgGuestFeedbackIntegration?: { __typename?: 'OrgGuestFeedbackIntegration', id: string, locationGroup?: { __typename?: 'LocationGroup', id: string, name: string } | null } | null } };

export type UpdateOrgGuestFeedbackIntegrationLocationMutationVariables = Types.Exact<{
  input: Types.UpdateOrgGuestFeedbackIntegrationLocationInput;
}>;


export type UpdateOrgGuestFeedbackIntegrationLocationMutation = { __typename?: 'Mutation', updateOrgGuestFeedbackIntegrationLocation: { __typename?: 'OrgGuestFeedbackIntegrationLocationMutationResult', success: boolean, error?: { __typename?: 'Error', message?: string | null } | null, orgGuestFeedbackIntegrationLocation?: { __typename?: 'OrgGuestFeedbackIntegrationLocation', id: string, location?: { __typename?: 'Location', id: number, name: string, address?: { __typename?: 'Address', lineOne: string, city: string, usState?: USState | null, postalCode: string } | null } | null } | null } };


export const OrgGuestFeedbackIntegrationSidebarDocument = gql`
    query OrgGuestFeedbackIntegrationSidebar($id: UUID!) {
  OrgGuestFeedbackIntegration(id: $id) {
    id
    enabled
    googleBusinessConfig {
      id
      accountId
    }
    locationGroup {
      id
      name
    }
    ovationIntegrationConfig {
      id
      companyId
    }
    tattleIntegrationConfig {
      id
      merchantId
    }
    locations {
      id
      sourceLocationId
      sourceName
      sourceAddress {
        lineOne
        city
        usState
        postalCode
      }
      location {
        id
        name
        address {
          lineOne
          city
          usState
          postalCode
        }
      }
    }
  }
}
    `;

/**
 * __useOrgGuestFeedbackIntegrationSidebarQuery__
 *
 * To run a query within a React component, call `useOrgGuestFeedbackIntegrationSidebarQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgGuestFeedbackIntegrationSidebarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgGuestFeedbackIntegrationSidebarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrgGuestFeedbackIntegrationSidebarQuery(baseOptions: Apollo.QueryHookOptions<OrgGuestFeedbackIntegrationSidebarQuery, OrgGuestFeedbackIntegrationSidebarQueryVariables> & ({ variables: OrgGuestFeedbackIntegrationSidebarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgGuestFeedbackIntegrationSidebarQuery, OrgGuestFeedbackIntegrationSidebarQueryVariables>(OrgGuestFeedbackIntegrationSidebarDocument, options);
      }
export function useOrgGuestFeedbackIntegrationSidebarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgGuestFeedbackIntegrationSidebarQuery, OrgGuestFeedbackIntegrationSidebarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgGuestFeedbackIntegrationSidebarQuery, OrgGuestFeedbackIntegrationSidebarQueryVariables>(OrgGuestFeedbackIntegrationSidebarDocument, options);
        }
export type OrgGuestFeedbackIntegrationSidebarQueryHookResult = ReturnType<typeof useOrgGuestFeedbackIntegrationSidebarQuery>;
export type OrgGuestFeedbackIntegrationSidebarLazyQueryHookResult = ReturnType<typeof useOrgGuestFeedbackIntegrationSidebarLazyQuery>;
export type OrgGuestFeedbackIntegrationSidebarQueryResult = Apollo.QueryResult<OrgGuestFeedbackIntegrationSidebarQuery, OrgGuestFeedbackIntegrationSidebarQueryVariables>;
export const GuestFeedbackIntegrationOpusLocationsDocument = gql`
    query GuestFeedbackIntegrationOpusLocations($input: LocationsInput, $pagination: PaginationInput) {
  Locations(input: $input, pagination: $pagination) {
    objects {
      id
      name
      address {
        lineOne
        city
        usState
        postalCode
      }
    }
  }
}
    `;

/**
 * __useGuestFeedbackIntegrationOpusLocationsQuery__
 *
 * To run a query within a React component, call `useGuestFeedbackIntegrationOpusLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestFeedbackIntegrationOpusLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestFeedbackIntegrationOpusLocationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGuestFeedbackIntegrationOpusLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GuestFeedbackIntegrationOpusLocationsQuery, GuestFeedbackIntegrationOpusLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GuestFeedbackIntegrationOpusLocationsQuery, GuestFeedbackIntegrationOpusLocationsQueryVariables>(GuestFeedbackIntegrationOpusLocationsDocument, options);
      }
export function useGuestFeedbackIntegrationOpusLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GuestFeedbackIntegrationOpusLocationsQuery, GuestFeedbackIntegrationOpusLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GuestFeedbackIntegrationOpusLocationsQuery, GuestFeedbackIntegrationOpusLocationsQueryVariables>(GuestFeedbackIntegrationOpusLocationsDocument, options);
        }
export type GuestFeedbackIntegrationOpusLocationsQueryHookResult = ReturnType<typeof useGuestFeedbackIntegrationOpusLocationsQuery>;
export type GuestFeedbackIntegrationOpusLocationsLazyQueryHookResult = ReturnType<typeof useGuestFeedbackIntegrationOpusLocationsLazyQuery>;
export type GuestFeedbackIntegrationOpusLocationsQueryResult = Apollo.QueryResult<GuestFeedbackIntegrationOpusLocationsQuery, GuestFeedbackIntegrationOpusLocationsQueryVariables>;
export const GuestFeedbackIntegrationBrandsDocument = gql`
    query GuestFeedbackIntegrationBrands {
  LocationGroups(input: {types: [BRAND]}) {
    objects {
      id
      name
    }
  }
}
    `;

/**
 * __useGuestFeedbackIntegrationBrandsQuery__
 *
 * To run a query within a React component, call `useGuestFeedbackIntegrationBrandsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuestFeedbackIntegrationBrandsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuestFeedbackIntegrationBrandsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGuestFeedbackIntegrationBrandsQuery(baseOptions?: Apollo.QueryHookOptions<GuestFeedbackIntegrationBrandsQuery, GuestFeedbackIntegrationBrandsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GuestFeedbackIntegrationBrandsQuery, GuestFeedbackIntegrationBrandsQueryVariables>(GuestFeedbackIntegrationBrandsDocument, options);
      }
export function useGuestFeedbackIntegrationBrandsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GuestFeedbackIntegrationBrandsQuery, GuestFeedbackIntegrationBrandsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GuestFeedbackIntegrationBrandsQuery, GuestFeedbackIntegrationBrandsQueryVariables>(GuestFeedbackIntegrationBrandsDocument, options);
        }
export type GuestFeedbackIntegrationBrandsQueryHookResult = ReturnType<typeof useGuestFeedbackIntegrationBrandsQuery>;
export type GuestFeedbackIntegrationBrandsLazyQueryHookResult = ReturnType<typeof useGuestFeedbackIntegrationBrandsLazyQuery>;
export type GuestFeedbackIntegrationBrandsQueryResult = Apollo.QueryResult<GuestFeedbackIntegrationBrandsQuery, GuestFeedbackIntegrationBrandsQueryVariables>;
export const UpdateOrgGuestFeedbackIntegrationBrandDocument = gql`
    mutation UpdateOrgGuestFeedbackIntegrationBrand($input: UpdateOrgGuestFeedbackIntegrationInput!) {
  updateOrgGuestFeedbackIntegration(input: $input) {
    success
    error {
      message
    }
    orgGuestFeedbackIntegration {
      id
      locationGroup {
        id
        name
      }
    }
  }
}
    `;
export type UpdateOrgGuestFeedbackIntegrationBrandMutationFn = Apollo.MutationFunction<UpdateOrgGuestFeedbackIntegrationBrandMutation, UpdateOrgGuestFeedbackIntegrationBrandMutationVariables>;

/**
 * __useUpdateOrgGuestFeedbackIntegrationBrandMutation__
 *
 * To run a mutation, you first call `useUpdateOrgGuestFeedbackIntegrationBrandMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrgGuestFeedbackIntegrationBrandMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrgGuestFeedbackIntegrationBrandMutation, { data, loading, error }] = useUpdateOrgGuestFeedbackIntegrationBrandMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrgGuestFeedbackIntegrationBrandMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrgGuestFeedbackIntegrationBrandMutation, UpdateOrgGuestFeedbackIntegrationBrandMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrgGuestFeedbackIntegrationBrandMutation, UpdateOrgGuestFeedbackIntegrationBrandMutationVariables>(UpdateOrgGuestFeedbackIntegrationBrandDocument, options);
      }
export type UpdateOrgGuestFeedbackIntegrationBrandMutationHookResult = ReturnType<typeof useUpdateOrgGuestFeedbackIntegrationBrandMutation>;
export type UpdateOrgGuestFeedbackIntegrationBrandMutationResult = Apollo.MutationResult<UpdateOrgGuestFeedbackIntegrationBrandMutation>;
export type UpdateOrgGuestFeedbackIntegrationBrandMutationOptions = Apollo.BaseMutationOptions<UpdateOrgGuestFeedbackIntegrationBrandMutation, UpdateOrgGuestFeedbackIntegrationBrandMutationVariables>;
export const UpdateOrgGuestFeedbackIntegrationLocationDocument = gql`
    mutation UpdateOrgGuestFeedbackIntegrationLocation($input: UpdateOrgGuestFeedbackIntegrationLocationInput!) {
  updateOrgGuestFeedbackIntegrationLocation(input: $input) {
    success
    error {
      message
    }
    orgGuestFeedbackIntegrationLocation {
      id
      location {
        id
        name
        address {
          lineOne
          city
          usState
          postalCode
        }
      }
    }
  }
}
    `;
export type UpdateOrgGuestFeedbackIntegrationLocationMutationFn = Apollo.MutationFunction<UpdateOrgGuestFeedbackIntegrationLocationMutation, UpdateOrgGuestFeedbackIntegrationLocationMutationVariables>;

/**
 * __useUpdateOrgGuestFeedbackIntegrationLocationMutation__
 *
 * To run a mutation, you first call `useUpdateOrgGuestFeedbackIntegrationLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrgGuestFeedbackIntegrationLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrgGuestFeedbackIntegrationLocationMutation, { data, loading, error }] = useUpdateOrgGuestFeedbackIntegrationLocationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrgGuestFeedbackIntegrationLocationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrgGuestFeedbackIntegrationLocationMutation, UpdateOrgGuestFeedbackIntegrationLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrgGuestFeedbackIntegrationLocationMutation, UpdateOrgGuestFeedbackIntegrationLocationMutationVariables>(UpdateOrgGuestFeedbackIntegrationLocationDocument, options);
      }
export type UpdateOrgGuestFeedbackIntegrationLocationMutationHookResult = ReturnType<typeof useUpdateOrgGuestFeedbackIntegrationLocationMutation>;
export type UpdateOrgGuestFeedbackIntegrationLocationMutationResult = Apollo.MutationResult<UpdateOrgGuestFeedbackIntegrationLocationMutation>;
export type UpdateOrgGuestFeedbackIntegrationLocationMutationOptions = Apollo.BaseMutationOptions<UpdateOrgGuestFeedbackIntegrationLocationMutation, UpdateOrgGuestFeedbackIntegrationLocationMutationVariables>;